import $ from 'jquery'

class Airport {
	//? 1. describe and create/initiate our object

	constructor() {
		//Verables
		this.events()
	}

	//?events
	events() {
		let myObj = this

		if (window.innerWidth > 765) {
			myObj.AirportFunction()
		} else {
			myObj.MobileAnimation()
		}
	}

	MobileAnimation() {
		let myTimeline = new TimelineLite()
		myTimeline
			.add('start', 0)
			.fromTo(
				'.hero-copy',
				1,
				{ opacity: 0, y: -100 },
				{ opacity: 1, delay: 1 },
				'start'
			)

		let myTimelineTwo = new TimelineMax({ repeat: -1, repeatDelay: 0 })
		myTimelineTwo
			.add('start', 2)
			.add('endFramOne', 4)
			.to('.hero-mobile-modal', 0.5, { opacity: 1 }, 'start')
			.fromTo(
				'.hero-mobile-line-one',
				1,

				{
					opacity: 0,
					clip: 'rect(0px,0px,1090px,0px)',
					ease: 'expo.out',
				},
				{
					opacity: 1,
					clip: 'rect(0px,1920px,1090px,0px)',
					ease: 'expo.out',
					delay: 0.2,
				},

				'start'
			)
			.to(
				'.hero-mobile-modal',
				0.5,
				{ opacity: 0, delay: 0.2 },
				'endFramOne'
			)
			.to(
				'.hero-mobile-line-one',
				1,
				{
					opacity: 0,
				},
				'endFramOne'
			)
			.to('.scale-all', 1, { x: -300, y: -100 })
			.to('.hero-mobile-modal-two', 0.5, { opacity: 1 })
			.fromTo(
				'.hero-mobile-line-two',
				1,

				{
					opacity: 0,
					clip: 'rect(0px,0px,1090px,0px)',
					ease: 'expo.out',
				},
				{
					opacity: 1,
					clip: 'rect(0px,1920px,1090px,0px)',
					ease: 'expo.out',
					delay: 0.2,
				}
			)
			.to('.hero-mobile-line-two', 1, {
				opacity: 0,
				delay: 0.5,
			})
			.to('.hero-mobile-modal-two', 0.5, { opacity: 0 })
			.to('.scale-all', 1, { x: -400, y: 0 })
			.to('.hero-mobile-modal-three', 0.5, { opacity: 1 })
			.fromTo(
				'.hero-mobile-line-three',
				1,

				{
					opacity: 0,
					clip: 'rect(0px,0px,1090px,0px)',
					ease: 'expo.out',
				},
				{
					opacity: 1,
					clip: 'rect(0px,1920px,1090px,0px)',
					ease: 'expo.out',
					delay: 0.2,
				}
			)
			.to('.hero-mobile-line-three', 1, {
				opacity: 0,
				delay: 0.5,
			})
			.to('.hero-mobile-modal-three', 0.5, { opacity: 0 })
			.to('.scale-all', 1, { x: 0, y: 0 })

		myTimelineTwo.timeScale(1.3)
	}

	//? 3. methods (functions)
	AirportFunction() {
		let myTimeline = new TimelineLite()

		myTimeline
			.add('start', 0)
			.to('.mainImg', 2, { opacity: 1 }, 'start')
			// .to('.scale-all', 1, { y: -100, delay: 1 }, 'start')
			.fromTo(
				'.hero-content',
				1,
				{ opacity: 0, y: 0 },
				{ opacity: 1, y: 0, delay: 1 },
				'start'
			)

		let myTimelineTwo = new TimelineLite()
		myTimelineTwo
			.add('start', 2)
			.staggerTo('.hero-modal', 0.3, { opacity: 1 }, 0.2, 'start')
			.staggerFromTo(
				'.hero-line',
				1,

				{
					opacity: 0,
					clip: 'rect(0px,0px,1090px,0px)',
					ease: 'expo.out',
				},
				{
					opacity: 1,
					clip: 'rect(0px,1920px,1090px,0px)',
					ease: 'expo.out',
					delay: 0.2,
				},
				0.2,
				'start'
			)

		// .to('.scale-all', 2, FOneP, 'start')
		// .from('.modal-one', 1, { opacity: 0, ease: 'expo.out' }, 'frameOne')
		// .fromTo(
		// 	'.modal-one-line',
		// 	1,
		// 	{
		// 		clip: 'rect(0px,0px,1090px,0px)',
		// 		ease: 'expo.out',
		// 	},
		// 	{
		// 		clip: 'rect(0px,1920px,1090px,0px)',
		// 		ease: 'expo.out',
		// 		delay: 0.8,
		// 	},
		// 	'frameOne'
		// )
		// .to('.scale-all', 2, FTwoP, 'frameTwo')
		// .from('.modal-two', 1, { opacity: 0, delay: 1 }, 'frameTwo')
		// .fromTo(
		// 	'.modal-two-line',
		// 	2,
		// 	{
		// 		clip: 'rect(0px,0px,1090px,0px)',
		// 		ease: 'expo.out',
		// 	},
		// 	{
		// 		clip: 'rect(0px,1920px,1090px,0px)',
		// 		ease: 'expo.out',
		// 		delay: 1.3,
		// 	},
		// 	'frameTwo'
		// )
		// .to('.scale-all', 2, fThreep, 'frameThree')
		// .from('.modal-three', 1, { opacity: 0, delay: 1 }, 'frameThree')
		// .fromTo(
		// 	'.modal-three-line',
		// 	2,
		// 	{
		// 		clip: 'rect(0px,1920px,0px,0px)',
		// 		ease: 'expo.out',
		// 	},
		// 	{
		// 		clip: 'rect(0px,1920px,1090px,0px)',
		// 		ease: 'expo.out',
		// 		delay: 1.3,
		// 	},
		// 	'frameThree'
		// )
		// .to('.hero-overlay', 0, { opacity: 0 }, 'final')
		// .to('.scale-all', 1, { scale: 1, x: 0, y: 0 }, 'final')
		// .to('.hero-overlay', 0, { opacity: 1, delay: 1 }, 'final')
		// .from('.gradient-ov', 1, { opacity: 0 }, 'final')
		// .to('.scale-all', 1, { y: -100, delay: 2 }, 'final')
		// .from('.hero-content', 1, { opacity: 0, y: 200, delay: 2 }, 'final')

		// // init controller
		// var controller = new ScrollMagic.Controller()

		// // build scene
		// var scene = new ScrollMagic.Scene({
		// 	triggerElement: '#heroHeader',
		// 	// offset: 0,
		// 	triggerHook: 'onLeave',
		// 	duration: window.innerHeight * 5,
		// 	// reverse: false,
		// })
		// 	.setTween(myTimeline) // trigger a TweenMax.to tween
		// 	// .addIndicators({ name: '1 (duration: 0)' })
		// 	.setPin('#heroHeader')
		// 	.addTo(controller)
	}
}

export default Airport
